import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/performance-review/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "performance-review" entry is kept); the seo block below is a fallback.

export const performanceReview: ContentPage = {
  slug: "employee-management-system/performance-review",
  template: "hrmsFeature",
  seo: {
    title: "Streamlined Performance Review System for Employee Growth",
    description: "Track and improve employee performance with goal setting, feedback, and performance reports to drive continuous development and productivity.",
    keywords: [
      "performance review software",
      "employee performance tracking",
      "KPI management",
      "feedback management",
      "performance evaluation tool.",
    ],
    ogImage: "/assets/data/seoimages/performance-review.webp",
  },
  leaf: {
    hero: {
      caption: "Performance Review",
      title: "Effective Performance Reviews for Continuous Improvement",
      description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
      h1: "caption",
    },
    split: {
      title: "Streamlined Performance Reviews for Employee Growth",
      bullets: [
        { title: "Goal Setting", description: "Define specific KPIs for each employee." },
        { title: "Feedback Management", description: "Deliver structured feedback during reviews." },
        { title: "Performance Reports", description: "Create detailed reports from reviews." },
        { title: "Achievement Tracking", description: "Monitor employee progress toward goals." },
      ],
      image: "/assets/images/img/product/hrms/employeems/performance_review_image.webp",
      imageAlt: "Image Description",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Attendance Tracking",
        href: "/hrms-software/employee-management-system/attendance-tracking",
        description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
        image: "/assets/images/img/product/hrms/employeems/attendance_tracking_images.webp",
        imageAlt: "attendance_tracking_key_features",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/employee-management-system/employee-shift-management",
        description: "Automate and organize shift scheduling, manage shift swaps, and ensure proper staffing with a powerful shift management system.",
        image: "/assets/images/img/product/hrms/employeems/shift_management.webp",
        imageAlt: "shift_management",
      },
      {
        title: "Employee Directory",
        href: "/hrms-software/employee-management-system/employee-directory",
        description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
        image: "/assets/images/img/product/hrms/employeems/employee_directory_image.webp",
        imageAlt: "employee_directory_key_features",
      },
      {
        title: "Payroll Integration",
        href: "/hrms-software/employee-management-system/payroll-integration/",
        description: "Integrate payroll with attendance and performance data to automate salary calculations and manage deductions, ensuring timely payroll processing.",
        image: "/assets/images/img/product/hrms/employeems/payroll_integration.webp",
        imageAlt: "leave_management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Enhance Your Team’s Performance with Easy Reviews!",
    relatedBlogs: "static",
    metaKey: "performance-review",
  },
  sections: [],
};
